const privacyPolicy = `
At Jiwe Esports, we take your privacy seriously. This privacy policy explains how we collect, use, and protect your personal information when you use our platform.


## Information we collect

We collect personal information that you provide to us when you sign up for our platform, participate in our tournaments, and communicate with us. This information may include your name, email address, phone number, date of birth, country of residence, and payment information.


We also collect non-personal information such as your IP address, browser type, device type, and usage data when you use our platform.



## How we use your information

We use your personal information to provide and improve our platform, process your payments, communicate with you, and comply with legal requirements. We may also use your personal information for marketing purposes, such as sending you newsletters and promotional offers. You can opt-out of receiving marketing communications at any time.


We may share your personal information with third-party service providers who help us operate our platform, such as payment processors and marketing agencies. We will only share your information with these third parties to the extent necessary to provide their services to us.



## How we protect your information

We take appropriate security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. These measures include using secure servers, encrypting data, and restricting access to your personal information to authorized personnel only.



## Your rights

You have the right to access, update, and delete your personal information. You can also object to the processing of your personal information or request that we restrict its processing. To exercise your rights, please contact us using the information provided at the end of this privacy policy.



## Changes to this policy

We may update this privacy policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes to this policy by posting a notice on our platform or sending you an email.



## Contact us



If you have any questions or concerns about this privacy policy or our practices regarding your personal information, please contact us at [rock@jiwe.io].

  

`;

export default privacyPolicy;
